import React, { Component } from "react";
import { connect } from "react-redux";
import { getValueFromLanguageObject } from "../../../store";
import { isInquiryOrCart } from "../../../actions";

// Lightweight SVG icon for column count (updated: no outer border, cleaner)
const GridIcon = ({ cols, active }) => {
  const size = 22;
  const gap = 2;
  const barGap = 2;
  const barWidth = (size - gap * 2 - barGap * (cols - 1)) / cols; // fit bars without outer stroke
  return (
    <svg
      width={size}
      height={size}
      viewBox={`0 0 ${size} ${size}`}
      role="img"
      aria-label={`${cols} column layout`}
    >
      {Array.from({ length: cols }).map((_, i) => {
        const x = gap + i * (barWidth + barGap);
        return (
          <rect
            key={i}
            x={x}
            y={gap}
            width={barWidth}
            height={size - gap * 2}
            rx="2"
            fill={active ? "#fff" : "#1252C9"}
          />
        );
      })}
    </svg>
  );
};

// Debounce utility
function debounce(func, wait) {
  let timeout;
  return function(...args) {
    clearTimeout(timeout);
    timeout = setTimeout(() => func.apply(this, args), wait);
  };
}

class FilterBar extends Component {
  state = {
    selectedView: "grid", // grid | list
    gridCols: 4, // default 4-grid
    searchText: "",
  };

  componentDidMount() {
    this.props.onLayoutViewClicked(4); // default 4-grid
    // Create debounced handler
    this.debouncedSearch = debounce(this.handleSearch, 400);
  }

  handleSearch = (value) => {
    // Call your API/filter function here
    if (this.props.onSearch) {
      this.props.onSearch(value);
    }
  };

  handleSearchInput = (e) => {
    const value = e.target.value;
    this.setState({ searchText: value });
    this.debouncedSearch(value);
  };

  handleGridLayout = (colSize) => {
    this.setState({ selectedView: "grid", gridCols: colSize });
    this.props.onLayoutViewClicked(colSize);
  };

  handleListLayout = () => {
    this.setState({ selectedView: "list" });
    this.props.onLayoutViewClicked(12);
  };

  render() {
    const { isInquiry, productList } = this.props;
    const { length } = productList || [];
    const { selectedView, gridCols, searchText } = this.state;

    return (
      <div className="row">
        {/* Left: Product count */}
        <div className="col-md-4 mb-3 mb-md-0">
          {`${getValueFromLanguageObject("str_showing_products") ||
            "Showing Products"} ${length} ${getValueFromLanguageObject(
            "str_results"
          ) || "Results"}`}
        </div>
        {/* Center: View toggle buttons */}
        <div className="col-md-4 mb-3 mb-md-0">
          <div
            className="btn-group grid-list-toggle d-none d-md-flex"
            role="group"
            aria-label="Grid and List toggle"
          >
            {/* Grid toggle */}
            <button
              type="button"
              aria-label="Grid view"
              className={`btn ${
                selectedView === "grid" ? "btn-primary" : "btn-light"
              }`}
              onClick={() => this.handleGridLayout(3)}
            >
              <i className="fa fa-th" />
            </button>

            {/* List toggle */}
            <button
              type="button"
              aria-label="List view"
              className={`btn ${
                selectedView === "list" ? "btn-primary" : "btn-light"
              }`}
              onClick={this.handleListLayout}
            >
              <i className="fa fa-list-ul" />
            </button>
          </div>
        </div>

        {/* Search input with debounce */}
        {/* <div className="col-md-3 mb-3 mb-md-0">
          <input
            type="text"
            className="form-control"
            placeholder={
              getValueFromLanguageObject("str_search_products") ||
              "Search products"
            }
            value={searchText}
            onChange={this.handleSearchInput}
            style={{ marginBottom: "10px" }}
          />
        </div> */}

        {/* Right: Sorting dropdown */}
        <div className="col-md-4" style={{ marginBottom: "24px" }}>
          <div className="d-flex align-items-center justify-content-end">
            <div style={{ width: "100%" }}>
              <select
                id="sortOptions"
                className="form-control rounded"
                style={{
                  minHeight: "44px",         // Ensures enough height for text
                  lineHeight: "1.5",         // Improves vertical alignment
                  fontSize: "16px",          // Adjust font size as needed
                  paddingTop: "10px",        // Extra top padding
                  paddingBottom: "10px",     // Extra bottom padding
                }}
                onChange={(e) =>
                  this.props.handleSortingProductFilter(e.target.value)
                }
              >
                <option value={1}>
                  {getValueFromLanguageObject("str_sorting_items") ||
                    "Sorting items"}
                </option>
                {!isInquiry && (
                  <>
                    <option value={2}>
                      {getValueFromLanguageObject("str_price_high_to_low") ||
                        "Price: High to Low"}
                    </option>
                    <option value={3}>
                      {getValueFromLanguageObject("str_price_low_to_high") ||
                        "Price: Low to High"}
                    </option>
                  </>
                )}
                <option value={4}>
                  {getValueFromLanguageObject("str_best_selling") ||
                    "Best Selling"}
                </option>
                <option value={5}>
                  {getValueFromLanguageObject("str_newest_products") ||
                    "Newest Products"}
                </option>
              </select>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  isInquiry: state.settings.isInquiry,
});

export default connect(mapStateToProps, {
  isInquiryOrCart: isInquiryOrCart,
})(FilterBar);
